var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#003D76",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    x: 8,
    y: 2,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 1.73 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoring);
export default __webpack_public_path__ + "static/media/scoring.baa0af9e81da9d2f2309eaabb00086a6.svg";
export { ForwardRef as ReactComponent };